import { castToOption } from 'src/helpers';

export enum CustomerLeadPurchaseReason {
  PriceComparison = 'PRICE_COMPARISON',
  GettingQuotesFutureProject = 'GETTING_QUOTES_FUTURE_PROJECT',
  VendorSupplyIssues = 'VENDOR_SUPPLY_ISSUES',
  UrgentNeed = 'URGENT_NEED',
}

export const CUSTOMER_LEAD_PURCHASE_REASON_MAPPER: Readonly<Record<CustomerLeadPurchaseReason, string>> = Object.freeze(
  {
    [CustomerLeadPurchaseReason.PriceComparison]: 'Price Comparison',
    [CustomerLeadPurchaseReason.GettingQuotesFutureProject]: 'Getting Quotes Future Project',
    [CustomerLeadPurchaseReason.VendorSupplyIssues]: 'Vendor Supply Issues',
    [CustomerLeadPurchaseReason.UrgentNeed]: 'Urgent Need',
  }
);

export const CustomerLeadPurchaseReasonOptions = castToOption(
  CustomerLeadPurchaseReason,
  CUSTOMER_LEAD_PURCHASE_REASON_MAPPER
);
